import React, { useContext } from 'react';

import { Button } from '../';
import ScreenTextContext from '../../contexts/ScreenTextContext';

export const Controls = ({disableSwap, hideSwap, swap}) => {


  const handleRestartClick = e => {
    e.preventDefault(); 
    window.location.reload();
  }

  const { screenText } = useContext(ScreenTextContext);  


  if (!screenText || !screenText.play ) {
    return ''; // Should return error? Loading?
  }

  

  return (
    <div className="play__controls">

      {/* Restart Button */}
      <Button 
        variant="text" 
        onClick={handleRestartClick}
      >
        <i className="fas fa-home"></i>&nbsp; {screenText.play.restart}
      </Button>

      {/* Swap Out Button */}
      {hideSwap ? '' :
        <Button 
          variant="text" 
          onClick={swap} 
          disabled={disableSwap}
        >
          <i className="fas fa-sync"></i>&nbsp; {screenText.play.swap}
        </Button>
      }

    </div>
  )
}